module.exports = __webpack_public_path__ + "img/sort-filter-red.cf2d3649.svg";